const initialData = {
    avatar: '',
    surname: '',
    firstName: '',
    gender: '',
    address: '',
    company: '',
    position: '',
    summary: '',
    telephone_employee: [
        {
            type: '',
            name: '',
            phone: ''
        },
    ],
    email_employee: [
        {
            name: '',
            email: ''
        },
    ],
    website_employee: [
        {
            name: 'Bravewood',
            url: 'https://www.bravewood.ng'
        },
    ],
    socials_employee: [
        {
            type: 'Facebook',
            name: 'Facebook',
            url: 'https://facebook.com/bravewoodng/'
        },
        {
            type: 'Twitter',
            name: 'Twitter',
            url: 'https://twitter.com/bravewoodng'
        },
        {
            type: 'Linkedin',
            name: 'Linkedin',
            url: 'https://www.linkedin.com/company/bravewoodng'
        },
        {
            type: 'Instagram',
            name: 'Instagram',
            url: 'https://www.instagram.com/bravewoodng/'
        },
    ],
}

export default initialData